import { Button, DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierActionList extends Layout {
    buttonAddAction: Button;
    panelSecondaryFilters: Panel;
    sourceCarrierAction: DataSource;
    tableActivities: Table;
}
